interface CookieAccess {
    setCookie: (type: 'functional', cookie: string) => void;
}

type CookieHandler = (access: CookieAccess) => void;

declare global {
    interface Window {
        cookieconsent?: CookieHandler[];
    }
}

/**
 * Uses Vrbo GDPR cookie consent API to set functional cookies only if user has consented
 * See API docs at https://github.expedia.biz/vrbo-web-platform/gdpr-banner
 * @param cookieToSet
 */
export default function vrboCookieConsentAdapter(cookieToSet: string) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }

    window.cookieconsent = window.cookieconsent || [];
    window.cookieconsent.push((cookieAccess) => {
        cookieAccess.setCookie('functional', cookieToSet);
    });
}
